import { useRef, type HTMLAttributes, type ReactNode } from "react";
import { useDialogFocus } from "../../hooks/useDialogFocus";

type TrappedPanelProps = HTMLAttributes<HTMLDivElement> & {
  sessionId?: string;
  children?: ReactNode;
};

/**
 * A dialog panel with its own Tab trap. Overlays drawn inside the task dialog
 * use this so they do not share that dialog's Tab cycle.
 */
export function TrappedPanel({
  sessionId,
  children,
  ...rest
}: TrappedPanelProps) {
  const panelRef = useRef<HTMLDivElement>(null);
  useDialogFocus(panelRef, sessionId);
  return (
    <div role="dialog" {...rest} ref={panelRef} tabIndex={-1} aria-modal="true">
      {children}
    </div>
  );
}
